import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { delay } from 'common/utils';

// global variable to keep the scroll positions
const scrollPositions: { [key: string]: { scrollY: number } } = {};

export const useScrollRestore = ({
    restoreOnMount,
    delayMs = 0,
}: {
    restoreOnMount: boolean;
    delayMs: number;
}) => {
    const history = useHistory();
    const [initialLocation] = useState(history.location.pathname);

    const restore = useCallback(async () => {
        if (scrollPositions[initialLocation]) {
            const { scrollY } = scrollPositions[initialLocation];
            const deltaY = scrollY - window.scrollY;

            if (delayMs > 0) {
                await delay(delayMs);
            }

            window.scrollBy({ left: 0, top: deltaY, behavior: 'smooth' });

            delete scrollPositions[initialLocation];
        }
    }, [initialLocation, delayMs]);

    useEffect(() => {
        if (restoreOnMount) {
            restore();
        }

        return () => {
            scrollPositions[initialLocation] = { scrollY: window.scrollY };
        };
    }, [initialLocation, restore, restoreOnMount]);

    return {
        restore,
    };
};
